<div class="split-auth-container">
  <!-- Left Panel -->
  <div class="split-left-panel">
    <div class="split-left-bg">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="split-left-img">
      <div class="split-left-overlay"></div>
    </div>
    <div class="split-left-content">
      <span class="left-tagline">A Heritage of Love</span>
      <h1 class="left-title">Find Your Perfect Life Partner</h1>
      <p class="left-desc">
        Experience a matrimonial journey built on tradition, family values, and curated connections. Where heritage
        meets modern search capabilities.
      </p>

      <div class="trust-badge-list">
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">verified_user</span>
          <div class="badge-text">
            <h4>Verified Profiles</h4>
            <p>Every account goes through a thorough check for secure matchmaking</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">chat</span>
          <div class="badge-text">
            <h4>Secure Messaging</h4>
            <p>Your privacy and safety are always our top concern</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">shield</span>
          <div class="badge-text">
            <h4>Privacy Protected</h4>
            <p>Full control over your photos and profile visibility</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="split-right-panel">
    <!-- Mobile-only Banner -->
    <div class="mobile-onboarding-banner">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="mobile-banner-img">
      <div class="mobile-banner-overlay"></div>
      <div class="mobile-banner-text">
        <span class="left-tagline">A Heritage of Love</span>
        <h3>Find Your Perfect Partner</h3>
      </div>
    </div>

    <div class="onboarding-card">
      <div class="auth-header">
        <a routerLink="/" class="logo">Weddingly Matrimony</a>

        <!-- Progress Stepper -->
        <div class="step-progress-wrapper">
          <span class="progress-step-text">Step 3 of 4: Personal Details</span>
          <div class="stepper-bar">
            <div class="stepper-progress" style="width: 75%;"></div>
          </div>
        </div>

        <h2>Personal Details</h2>
        <p>Tell us about your lifestyle, appearance, and upload a profile photo</p>
      </div>

      <form [formGroup]="signuppersonal" (ngSubmit)="onSubmit()" class="auth-form">
        <!-- Image Upload Area -->
        <div class="form-group photo-upload-group">
          <label>Profile Photo</label>
          <div class="photo-uploader" [class.has-preview]="imagePreview">
            <input type="file" id="avatarFile" (change)="onFileChange($event)" accept="image/*"
              class="hidden-file-input">
            <label for="avatarFile" class="uploader-label">
              <ng-container *ngIf="!imagePreview; else previewTemplate">
                <span class="material-symbols-outlined upload-icon">add_a_photo</span>
                <span class="upload-text">Upload Photo</span>
              </ng-container>
              <ng-template #previewTemplate>
                <img [src]="imagePreview" alt="Profile Preview" class="upload-preview-img">
                <span class="change-photo-badge">Change Photo</span>
              </ng-template>
            </label>
          </div>
          <span class="error-msg"
            *ngIf="signuppersonal.get('avatar')?.touched && signuppersonal.get('avatar')?.invalid">
            Profile photo is required
          </span>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="height">Height</label>

            <div class="input-with-icon search-dropdown">

              <span class="material-symbols-outlined input-icon">
                straighten
              </span>


              <!-- Selected value box -->
              <div class="warm-input selected-box" (click)="openDropdown('height'); $event.stopPropagation()">

                {{ selectedHeight || 'Select Height' }}

                <span class="arrow">▼</span>

              </div>



              <!-- Dropdown list -->
              <div class="dropdown-list" *ngIf="showHeightList">

                <!-- Search -->
                <input type="text" class="search-box" placeholder="Search height"
                  (input)="searchDropdown($event,'height')" (click)="$event.stopPropagation()">



                <!-- Height values -->
                <div class="dropdown-item" *ngFor="let h of filteredHeightList" (click)="selectDropdown(h,'height')">

                  {{ h }}

                </div>


              </div>

            </div>


            <span class="error-msg"
              *ngIf="signuppersonal.get('height')?.touched && signuppersonal.get('height')?.invalid">
              Height is required
            </span>

          </div>

          <div class="col-md-6 form-group">
            <label for="weight">Weight</label>

            <div class="input-with-icon search-dropdown">

              <span class="material-symbols-outlined input-icon">
                fitness_center
              </span>


              <!-- Selected Weight -->
              <div class="warm-input selected-box" (click)="openDropdown('weight'); $event.stopPropagation()">

                {{ selectedWeight || 'Select Weight' }}

                <span class="arrow">▼</span>

              </div>



              <!-- Dropdown -->
              <div class="dropdown-list" *ngIf="showWeightList">

                <!-- Search -->
                <input type="text" class="search-box" placeholder="Search weight"
                  (input)="searchDropdown($event,'weight')" (click)="$event.stopPropagation()">



                <!-- Weight list -->
                <div class="dropdown-item" *ngFor="let w of filteredWeightList" (click)="selectDropdown(w,'weight')">

                  {{ w }}

                </div>


              </div>


            </div>


            <span class="error-msg"
              *ngIf="signuppersonal.get('weight')?.touched && signuppersonal.get('weight')?.invalid">
              Weight is required
            </span>

          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="marital">Marital Status</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">favorite</span>
              <div class="warm-input selected-box" (click)="openDropdown('marital'); $event.stopPropagation()">
                {{ selectedMarital || 'Select Marital Status' }}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showMaritalList">
                <input type="text" class="search-box" placeholder="Search status" (input)="searchDropdown($event,'marital')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let m of filteredMaritalList" (click)="selectDropdown(m,'marital')">
                  {{ m }}
                </div>
              </div>
            </div>
            <span class="error-msg" *ngIf="signuppersonal.get('marital')?.touched && signuppersonal.get('marital')?.invalid">
              Marital status is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label>Physical Status</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">accessibility_new</span>
              <div class="warm-input selected-box" (click)="openDropdown('physical'); $event.stopPropagation()">
                {{selectedPhysical || 'Select Status'}}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showPhysicalList">
                <input type="text" class="search-box" placeholder="Search Status" (input)="searchDropdown($event,'physical')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let p of filteredPhysicalList" (click)="selectDropdown(p,'physical')">
                  {{p}}
                </div>
              </div>
            </div>
            <span class="error-msg" *ngIf="signuppersonal.get('physical')?.touched && signuppersonal.get('physical')?.invalid">
              Physical status is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label>Food Habit *</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">restaurant</span>
              <div class="warm-input selected-box" (click)="openDropdown('food'); $event.stopPropagation()">
                {{selectedFood || 'Select Food Habit'}}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showFoodList">
                <input type="text" class="search-box" placeholder="Search Food" (input)="searchDropdown($event,'food')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let f of filteredFoodList" (click)="selectDropdown(f,'food')">
                  {{f}}
                </div>
              </div>
            </div>
            <span class="error-msg" *ngIf="signuppersonal.get('food')?.touched && signuppersonal.get('food')?.invalid">
              Eating habits is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label>Smoking</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">smoking_rooms</span>
              <div class="warm-input selected-box" (click)="openDropdown('smoking'); $event.stopPropagation()">
                {{selectedSmoking || 'Select Smoking'}}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showSmokingList">
                <input type="text" class="search-box" placeholder="Search Smoking" (input)="searchDropdown($event,'smoking')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let s of filteredSmokingList" (click)="selectDropdown(s,'smoking')">
                  {{s}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label>Drinking</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">local_bar</span>
              <div class="warm-input selected-box" (click)="openDropdown('drinking'); $event.stopPropagation()">
                {{selectedDrinking || 'Select Drinking'}}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showDrinkingList">
                <input type="text" class="search-box" placeholder="Search Drinking" (input)="searchDropdown($event,'drinking')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let d of filteredDrinkingList" (click)="selectDropdown(d,'drinking')">
                  {{d}}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 form-group">
            <label>Body Type</label>
            <div class="input-with-icon search-dropdown">
              <span class="material-symbols-outlined input-icon">person</span>
              <div class="warm-input selected-box" (click)="openDropdown('body'); $event.stopPropagation()">
                {{selectedBody || 'Select Body Type'}}
                <span class="arrow">▼</span>
              </div>
              <div class="dropdown-list" *ngIf="showBodyList">
                <input type="text" class="search-box" placeholder="Search Body Type" (input)="searchDropdown($event,'body')" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let b of filteredBodyList" (click)="selectDropdown(b,'body')">
                  {{b}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" class="gold-button submit-btn">
          <span>Continue</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>

        <div class="trust-note">
          <span class="material-symbols-outlined trust-lock">lock</span>
          <span>Your information is private and secure</span>
        </div>
      </form>
    </div>
  </div>
</div>